import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink } from 'react-router-dom'
import slider1 from '../assets/stephi/banner1.jpg';
import homebanner from '../assets/stephi/home-banner.jpg';
import slider2 from '../assets/stephi/banner2.jpg';
import slider3 from '../assets/stephi/banner3.jpg';
import banner1 from '../assets/stephi/section2-1.jpg';
import banner2 from '../assets/stephi/section2-2.jpg';
import banner3 from '../assets/slider/male/section2-3.jpg';
import image1 from '../assets/slider/male/section5-image1.jpg';
import image2 from '../assets/slider/male/section5-image2.jpg';
import image3 from '../assets/slider/male/section5-image3.jpg';
import image4 from '../assets/slider/male/section5-image4.png';
import Products2 from "./Products2";
import Productslider from "./Productslider";
import Productslider2 from "./Productslider2";
import Productslider3 from "./Productslider3";


import './Header.css';
import BrandFocusSlider from "./BrandFocusSlider";
import Brandlogos from "./Brandlogos";
import ozdilekImage from "../assets/stephi/ozdilek.jpg";
import karacaImage from "../assets/stephi/karaca.jpg";
import timberlandImage from "../assets/brandImages/kids/timberland-kids.jpg";
import geoxImage from "../assets/brandImages/kids/geox-kids.jpg";
import video from '../assets/stephi/shtepi.webm';
// import "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css";

export default function Stephi() {

  const vidRef = useRef();

  useEffect(() => {
    // vidRef.current.play();
  }, []);

  return (

    <div className="">
      <div className="cover-section">
        <div id="mycarousel" className="carousel carousel-fade " data-bs-ride="carousel" data-bs-interval="6000">
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#mycarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
            {/* <button type="button" data-bs-target="#mycarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#mycarousel" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
          </div>
          <div className="carousel-inner">

            <div className="carousel-item active">
              <img
                src={homebanner}
                alt=""
                width="100%"
                className="w-full max-h-[380px] sm:max-h-[500px] lg:max-h-[560px] object-cover"
              />
              {/* <div className="carousel-heading">
                <div className="caption-1 animate__animated animate__slideInUp"></div>
                <div className="caption-2 animate__animated animate__slideInUp">Rehati në</div>
                <div className="caption-3 animate__animated animate__slideInUp">shtëpinë tuaj</div>
                <div className="caption-4 animate__animated animate__slideInUp"></div>
                <div className="caption-link slider-btn animate__animated animate__slideInUp">
                  <NavLink to="/brands/ozdilek?gender=life"><span>SHIKO KOLEKSIONIN</span></NavLink>
                </div>
              </div> */}
            </div>
            {/* 
            <div className="carousel-item">
              <img src={slider2} alt="" width="100%" />
              <div className="carousel-heading">
                <div className="caption-1 animate__animated animate__slideInRight">Fashion trends</div>
                <div className="caption-2 animate__animated animate__slideInRight">Përjetoni butësinë </div>
                <div className="caption-3 animate__animated animate__slideInRight">me peshqirët tanë</div>
                <div className="caption-4 animate__animated animate__slideInRight">Jeto momentin</div>
                <div className="caption-link slider-btn animate__animated animate__slideInRight">
                  <NavLink to="/brands/ozdilek?gender=life"><span>SHIKO KOLEKSIONIN</span></NavLink>
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <img src={slider3} alt="" width="100%" />
              <div className="carousel-heading">
                <div className="caption-1 animate__animated animate__slideInLeft"></div>
                <div className="caption-2 animate__animated animate__slideInLeft">PËRJETO</div>
                <div className="caption-3 animate__animated animate__slideInLeft">MOMENTIN TËND</div>
                <div className="caption-4 animate__animated animate__slideInLeft"></div>
                <div className="caption-link slider-btn animate__animated animate__slideInLeft">
                  <NavLink to="/brands/ozdilek?gender=life"><span>SHIKO KOLEKSIONIN</span></NavLink>
                </div>
              </div>
            </div> */}

          </div>
        </div>
      </div>

      <div className="cart-section mt-10 sm:mt-20">
        <div className="flex container py-4 mx-auto 1st justify-between items-center">
          <div className="title_block">
            Më të rejat
          </div>
          <div className="pr-7">
            <NavLink to="/new-arrivals?gender=life" className="text-sm text-gray-600 hover:text-black transition-colors">
              Shiko më shumë
            </NavLink>
          </div>
        </div>
        <Productslider start='1' limit='20' type='newin' />
        <div className="flex container py-4 mx-auto 1st mt-9 justify-between items-center">
          <div className="title_block">
            Top Zgjedhjet
          </div>
          <div className="pr-7">
            <NavLink to="/top-picks?gender=life" className="text-sm text-gray-600 hover:text-black transition-colors">
              Shiko më shumë
            </NavLink>
          </div>
        </div>
        <Productslider start='1' limit='20' type='toppicks' />
      </div>
      <div className='section-5 video-sec'>
        <div id="shopify-section-16141564777b64a0a2" className="shopify-section index-section section-video wow fadeInUp  animated">

          <div data-section-id="16141564777b64a0a2">
            <div className="distance">
              <div className="container-1320">
                <div className="block">
                  <div className="item youtube position-relative">
                    <video src={video} muted autoPlay loop width='100%' height='100%' webkit-playsinline="true" playsInline />


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex container py-4 mx-auto 1st mt-10">
        <div className="title_block text-center w-full">
          Në Fokus
        </div>
      </div>
      <div className={'brand-focus-slider kids-brand-focus'}>
        <NavLink to={`/brands/ozdilek`} aria-label={'ozdilek'}
          className="group w-full p-4 flex items-center justify-center">
          <div
            className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl">
            <span className={'absolute bottom-0 left-0 p-1 w-full rounded-tl-md'} style={{
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
              backdropFilter: 'blur(10px)',
            }}>
              <img
                style={{ height: 150, margin: '-25px 0' }}
                src={'https://appapi.albionline.com/vendorImages/Ozdilek.svg'}
                alt={'ozdilek'}
                className="mx-auto object-contain w-full"
                loading="lazy"
                width="200"
                height="100"
              />
            </span>
            <img
              src={ozdilekImage}
              alt={'ozdilek'}
              className="w-full"
              loading="lazy"
              width="200"
              height="80"
            />
          </div>
        </NavLink>
        <NavLink to={`/brands/karaca-home`} aria-label={'karaca'}
          className="group w-full p-4 flex items-center justify-center">
          <div
            className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl">
            <span className={'absolute bottom-0 left-0 p-1 w-full rounded-tl-md'} style={{
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
              backdropFilter: 'blur(10px)',
            }}>
              <img
                style={{ height: 150, margin: '-25px 0' }}
                src={'https://appapi.albionline.com/vendorImages/Karaca-Home.svg'}
                alt={'karaca'}
                className="mx-auto object-contain w-full"
                loading="lazy"
                width="200"
                height="100"
              />
            </span>
            <img
              src={karacaImage}
              alt={'karaca'}
              className="w-full"
              loading="lazy"
              width="200"
              height="80"
            />
          </div>
        </NavLink>

      </div>
    </div>
  )
}